import Options from "../options/Options";

export default class SessionController {

    static startSession(_app, target, sessionState, promptGoals, mode, promptSubmitted) {
        this.app = _app;
        this.target = target;
        this.isInSession = true;
        this.isWatching = false;
        this.isPromptSubmitted = promptSubmitted || false;
        this.lastConfig = sessionState || "";
        this.promptGoals = Array.isArray(promptGoals) ? promptGoals : [promptGoals];;
        this.mode = mode;

        if (mode == "present") {
            this.pauseInteractive();
        }
        if (sessionState) {
            this.app.loadConfigurationStringTemp(sessionState);
        }

        if (promptSubmitted) {
            this.pauseInteractive();
        }

        this.checkForUpdate();
    }

    static checkForUpdate() {
        setTimeout(() => {
            if (!this.isWatching) {
                const config = this.app.getConfigString();
                if (config != this.lastConfig) {
                    this.lastConfig = config;
                    this.sendUpdate(config);
                }
            }

            this.checkForUpdate();
        }, 100);
    }

    static sendUpdate(configuration) {
        const message = {
            type: 'configuration',
            configuration: configuration,
            name: this.target,
        }
        window.top.postMessage(message, '*');
    }

    static useWatchedConfiguration(configuration) {
        if (!this.isInSession) return;

        if (!this.isWatching) {
            this.lastConfig = this.app.getConfigString();
            this.pauseInteractive();
        }

        this.app.loadConfigurationStringTemp(configuration);
    }

    static stopWatching() {
        if (!this.isInSession) return;

        if (!this.isPromptSubmitted) {
            this.resumeInteractive();
        }

        this.app.loadConfigurationStringTemp(this.lastConfig);
    }

    static submitAssessment() {
        if (this.isWatching) {
            this.app.loadConfigurationStringTemp(this.lastConfig);
        } else {
            this.pauseInteractive();
        }

        this.sendAssessment();

        this.isPromptSubmitted = true;
    }

    static sendAssessment() {
        if (this.mode == "assess") {
            const configuration = this.app.getConfigString();
            const configCorrect = this.app.doesConfigMatch(this.promptGoals);
            const result = {
                type: 'submission-status',
                correct: configCorrect,
                configuration: configuration,
                name: this.target,
            }

            window.top.postMessage(result, event.origin);
        }
    }

    static pauseInteractive() {
        this.isWatching = true;
        this.app.togglePointerEvents(false);
        document.body.dispatchEvent(new CustomEvent("watching-user", { detail: { isWatchingUser: true } }));
    }

    static resumeInteractive() {
        this.isWatching = false;
        this.app.togglePointerEvents(true);
        document.body.dispatchEvent(new CustomEvent("watching-user", { detail: { isWatchingUser: false } }));
    }

    static getAuthoredAssessment(app, name) {
        window.top.postMessage({
            type: "return-authored-assessment",
            name: name,
            goal: app.getGoalConfiguration(),
            current: app.getConfigString(),
            options: Options.getAuthoredOptions(),
        }, "*");
    }
}